import $ from 'jquery'
import {createApp} from 'vue'

import App from './App'
import utils from './utils'
import {pinia} from "../../Extensions/Wishlist";

$('.tiles-app-root').each((i, elem) => {
    let numTiles = parseInt($(elem).attr('data-num-tiles')) || 8;
    let tilesData = $(elem).children('script.tiles-data').html();
    let adTilesData = $(elem).children('script.ad-tiles-data').html();
    let translationData = $(elem).children('script.translation-data').html();
    let filterCategoriesData = $(elem).children('script.filter-categories-data').html();
    let seasonsData = $(elem).children('script.seasons-data').html();

    /** @type {AnyTile[]} */
    let tiles = JSON.parse(tilesData);
    let adTiles = JSON.parse(adTilesData);
    let translations = JSON.parse(translationData);
    let filterCategories = filterCategoriesData ? JSON.parse(filterCategoriesData) : null;
    let seasons = seasonsData ? JSON.parse(seasonsData) : null;

    let $app = $(elem).children('.app');
    const app = createApp(App, {
        tiles: tiles,
        adTiles: adTiles,
        filterCategories: filterCategories,
        seasons: seasons?.seasons,
        seasonPreselect: seasons?.preSelect,
        numTiles: [4, 8, 12, 16].includes(numTiles) ? numTiles : 8,
        _: utils.makeTranslator(translations),
    });
    app.use(pinia);
    app.mount($app[0]);
});
